var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotePad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8H8.66667C8.22464 8 7.80072 8.17559 7.48816 8.48816C7.17559 8.80072 7 9.22464 7 9.66667V21.3333C7 21.7754 7.17559 22.1993 7.48816 22.5118C7.80072 22.8244 8.22464 23 8.66667 23H20.3333C20.7754 23 21.1993 22.8244 21.5118 22.5118C21.8244 22.1993 22 21.7754 22 21.3333V15.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9227 7.52798C20.2607 7.18992 20.7193 7 21.1973 7C21.6754 7 22.134 7.18992 22.472 7.52798C22.8101 7.86605 23 8.32456 23 8.80265C23 9.28075 22.8101 9.73926 22.472 10.0773L14.3991 18.1502L11 19L11.8498 15.6009L19.9227 7.52798Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotePad);
export default __webpack_public_path__ + "static/media/Icon_NotePad.2b3b41dda5704f36be12282c77787ff6.svg";
export { ForwardRef as ReactComponent };